<template>
	<div class="row">
		<div class="col-xs-6 col-md-6">
			<div class="form-group">
				<input
				v-validate="validate"
				:ref="name"
				class="form-control"
				:class="{'is-invalid': errors.has(name)}"

				:id="id"
				:type="type"
				:name="name"
				:autocomplete="autocomplete"
				:placeholder="placeholder"

				v-model="real_value"

				v-on:input="$emit('input', $event.target.value)"></input>

				<div v-if="errors.has(name)" class="invalid-feedback">{{ errors.first(name) }}</div>
			</div>
		</div>
		<div class="col-xs-12 col-md-6">
			<div class="form-group">
				<input
				v-validate="Object.assign({}, validate, { 'confirmed': name })"
				:ref="confirm_name ? confirm_name : name + '_confirm'"
				class="form-control"
				:class="{ 'is-invalid': errors.has(confirm_name ? confirm_name : name + '_confirm') }"

				:type="type"
				:name="confirm_name ? confirm_name : name + '_confirm'"
				:autocomplete="autocomplete"
				:placeholder="confirm_placeholder ? confirm_placeholder :  placeholder"

				v-model="comfirm_value"
				:data-vv-as="name"></input>

				<div v-if="errors.has(confirm_name ? confirm_name : name + '_confirm')" class="invalid-feedback">{{ errors.first(confirm_name ? confirm_name : name + '_confirm') }}</div>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name: 'CsInputConfirm',
	props: {
		validate: {
			type: Object,
			default(){
				return {};
			}
		},
		// base
		value: {
			type: String,
			default: ''
		},
		label: {
			type: String,
			default: 'text'
		},
		id: {
			type: String,
			default: ''
		},
		name: {
			type: String,
			default: ''
		},
		confirm_name: {
			type: String,
			default: ''
		},
		type: {
			type: String,
			default: 'text'
		},
		placeholder: {
			type: String,
			default: ''
		},
		confirm_placeholder: {
			type: String,
			default: ''
		},


		// statussen
		disabled: {
			type: Boolean,
			default: false,
		},
		error: {
			type: String,
			default: ''
		},


		// misc
		autocomplete: {
			type: String,
			default: ''
		},
	},
	data(){
		return {
			real_value: '',
			comfirm_value: ''
		}
	},
	watch: {
		value(newValue){
			if(this.real_value != newValue){
				this.real_value = newValue;
			}
		}
	}
}
</script>

<style lang="scss">
@import '../../styles/config';

</style>



// WEBPACK FOOTER //
// src/components/Forms/CsInputConfirm.vue